export const fieldHelperStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
  marginTop: '4px',
};
